/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  createWithAttachments({ short_code, content, files = [] }) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', short_code);
    formData.append('canned_response[content]', content);
    files.forEach(file => {
      formData.append('canned_response[files][]', file);
    });
    return axios.post(this.url, formData);
  }

  updateWithAttachments(
    id,
    { short_code, content, files = [], removedAttachmentIds = [] }
  ) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', short_code);
    formData.append('canned_response[content]', content);
    files.forEach(file => {
      formData.append('canned_response[files][]', file);
    });
    removedAttachmentIds.forEach(blobId => {
      formData.append('canned_response[removed_attachment_ids][]', blobId);
    });
    return axios.put(`${this.url}/${id}`, formData);
  }
}

export default new CannedResponse();
